import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { State } from "./State";

var isArray = require("lodash/isArray");

var take = require("lodash/take");

var size = require("lodash/size");

var without = require("lodash/without");

var indexOf = require("lodash/indexOf");

var update = require("immutability-helper");

export var LevelState =
/*#__PURE__*/
function (_State) {
  _inherits(LevelState, _State);

  function LevelState() {
    _classCallCheck(this, LevelState);

    return _possibleConstructorReturn(this, _getPrototypeOf(LevelState).apply(this, arguments));
  }

  _createClass(LevelState, [{
    key: "getValue",
    value: function getValue() {
      return this.value || [];
    }
  }, {
    key: "add",
    value: function add(level, val) {
      var ob = this.getValue();

      if (!isArray(ob[level])) {
        ob = update(ob, _defineProperty({}, level, {
          $set: []
        }));
      }

      ob = update(ob, _defineProperty({}, level, {
        $push: [val]
      }));
      return this.create(ob);
    }
  }, {
    key: "contains",
    value: function contains(level, val) {
      return indexOf(this.getValue()[level], val) !== -1;
    }
  }, {
    key: "clear",
    value: function clear() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.create(take(this.getValue(), level));
    }
  }, {
    key: "remove",
    value: function remove(level, val) {
      return this.create(update(this.getValue(), _defineProperty({}, level, {
        $set: without(this.getValue()[level], val)
      })));
    }
  }, {
    key: "toggle",
    value: function toggle(level, val) {
      if (this.contains(level, val)) {
        return this.remove(level, val);
      } else {
        return this.add(level, val);
      }
    }
  }, {
    key: "getLevel",
    value: function getLevel(level) {
      return this.getValue()[level] || [];
    }
  }, {
    key: "levelHasFilters",
    value: function levelHasFilters(level) {
      return this.getLevel(level).length > 0;
    }
  }, {
    key: "getLeafLevel",
    value: function getLeafLevel() {
      return size(this.value) - 1;
    }
  }, {
    key: "isLeafLevel",
    value: function isLeafLevel(level) {
      return level === this.getLeafLevel();
    }
  }, {
    key: "toggleLevel",
    value: function toggleLevel(level, key) {
      if (this.contains(level, key)) {
        if (this.isLeafLevel(level)) {
          return this.clear(level);
        } else {
          return this.clear(level + 1);
        }
      } else {
        return this.clear(level).add(level, key);
      }
    }
  }]);

  return LevelState;
}(State);